<div class="contents">
  <app-back-button></app-back-button>
  <div class="header">
    <div class="instituicao-info">
      <div class="name-area">
        <div class="avatar">
          <p-avatar
            *ngIf="!imageError && imagePreview; else defaultAvatar"
            [image]="$any(imagePreview)"
            shape="circle"
            size="xlarge"
            (onImageError)="imageError = true"
          />
          <ng-template #defaultAvatar>
            <p-avatar
              [label]="getInitials(profileEducationalInstitution?.nome)"
              [icon]="!profileEducationalInstitution?.nome ? 'pi pi-building' : undefined"
              shape="circle"
              size="xlarge"
            />
          </ng-template>
        </div>
        <div class="left-area">
          <span class="name" [style.text-transform]="'uppercase'">{{ profileEducationalInstitution?.nome}}</span>
          <div class="d-flex flex-row align-items-center gap-2">
            <span class="full-name">{{ profileEducationalInstitution?.sigla}}</span>
            <span><p-tag *ngIf="profileEducationalInstitution?.isActive" severity="success" value="Activo" />
              <p-tag *ngIf="!profileEducationalInstitution?.isActive" severity="danger" value="Inactivo" />
            </span>
          </div>
        </div>
        <!-- <div class="indicator">
          <div class="book">
            <img src="icons/users-01.svg" alt="Country Icon" />
          </div>
          <div class="text-bg">
            <span>{{courseCount || '0'}} Cursos</span>
          </div>
        </div> -->
      </div>
      <div class="contact-info">
        <div class="country">
          <div class="icon">
            <img src="icons/globe.svg" alt="Country Icon" />
          </div>
          <span>{{ profileEducationalInstitution?.endereco }}</span>
        </div>
        <div class="phone">
          <div class="icon">
            <img src="icons/phone.svg" alt="Phone Icon" />
          </div>
          <!-- <span>{{ profileEducationalInstitution?.telefone }}</span> -->
          <span>{{ getPhoneWithCountryCode() }}</span>
        </div>
        <div class="email">
          <div class="icon">
            <img src="icons/email.svg" alt="Email Icon" />
          </div>
          <span>{{ profileEducationalInstitution?.email }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <p-button label="Editar instituição" icon="pi pi-pencil" severity="secondary" iconPos="right"
      (onClick)="showDialog()" />

    <p-button *ngIf="profileEducationalInstitution?.isActive" label="Desativar instituição" icon="pi pi-ban"
      severity="danger" (onClick)="toggleStatus()">
    </p-button>

    <p-button *ngIf="!profileEducationalInstitution?.isActive" label="Ativar instituição" icon="pi pi-check"
      severity="info" (onClick)="toggleStatus()">
    </p-button>

    <p-button label="Eliminar instituição" icon="pi pi-trash" severity="danger" [outlined]="true" iconPos="right"
      (onClick)="deleteInstitution(instituicaoEnsinoId || profileEducationalInstitution?.id)" />

    <p-button label="Mais detalhes da instituição" icon="pi pi-info-circle" [outlined]="true" iconPos="right"
      severity="secondary" (onClick)="actionClick(instituicaoEnsinoId||profileEducationalInstitution?.id)" />
    <!-- <p-button label="Criar unidade orgânica" icon="pi pi-warehouse" severity="info" [outlined]="true" iconPos="right"
      (onClick)="CreateOrgUnit(instituicaoEnsinoId||profileEducationalInstitution?.id)" /> -->
    <!-- <p-button label="Elimina Instituição" icon="pi pi-trash" severity="danger" [outlined]="true" iconPos="right"
      (onClick)="deleteInstitution(instituicaoEnsinoId||profileEducationalInstitution?.id)" /> -->

  </div>

  <p-tabs [(value)]="activeTab" (valueChange)="onTabClick(+$event)">

    <p-tablist>

      <p-tab [value]="0" style="text-transform: uppercase;">
        <div class="tab-icon">
          <img src="icons/building-08.svg" alt="Email Icon">
        </div>
        Unidade orgânica
      </p-tab>

      <p-tab [value]="1" style="text-transform: uppercase;">
        <div class="tab-icon">
          <img src="icons/users-01.svg" alt="Email Icon" />
        </div>
        Cursos
      </p-tab>

      <p-tab [value]="2" style="text-transform: uppercase;">
        <div class="tab-icon">
          <img src="icons/book-closed.svg" alt="Email Icon" />
        </div>
        Estudantes
      </p-tab>

      <p-tab [value]="3" style="text-transform: uppercase;">
        <div class="tab-icon">
          <img src="icons/users-01.svg" alt="Email Icon" />
        </div>
        Representantes
      </p-tab>

    </p-tablist>

    <p-tabpanels>

      <p-tabpanel [value]="0">
        <app-unidade-organica-list
          [insituicaoEnsinoID]="instituicaoEnsinoId||profileEducationalInstitution?.id"></app-unidade-organica-list>
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <p class="m-0">
          <app-instituicoes-ensino-listar-cursos
            (courseCount)="setCourseCount($event)"></app-instituicoes-ensino-listar-cursos>
        </p>
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <app-instituicoes-ensino-listar-bolseiros></app-instituicoes-ensino-listar-bolseiros>
      </p-tabpanel>

      <p-tabpanel [value]="3">
        <app-search-bar [showFilterBtn]="true" (onFilterBtnClick)="showFilterModal()"
          primaryBtnLabel="Novo Representante" (onPrimaryBtnClick)="addRepresentante()"
          (formValueChange)="handleFormValueChange($event)"></app-search-bar>

        <ng-container *ngIf="pagination?.data?.length; else noDataRepresent">
          <app-representante-card *ngFor="let representante of pagination.data; trackBy: trackById"
            [representante]="representante" [foto]="fotoPreviewMap[representante.id]"
            [instituicaoEnsino]="profileEducationalInstitution" (edit)="editarRepresentante($event)"
            (delete)="deleteRepresentante($event)" (redefinirSenha)="redefinirSenhaRepresentante($event)"
            (notificar)="notificarRepresentante($event)"></app-representante-card>

          <div class="pagination-controls">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPageChange($event)">
            </app-paginator-control>
          </div>
        </ng-container>

        <ng-template #noDataRepresent>
          <div class="no-data">
            <app-data-void [titulo]="'Nenhum representante encontrado'"
              [descricao]="'Clique em adicionar representante para criar um'"></app-data-void>
          </div>
        </ng-template>
      </p-tabpanel>

    </p-tabpanels>

  </p-tabs>

  <p-toast></p-toast>
  <p-confirmdialog>
    <ng-template #message let-message>
      <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
        <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmdialog>

  <p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <ng-template #headless>
      @if (maisDetalheInstituicao) {
      <app-mais-detalhes-intituicao-ensino [instituicaoSelected]="maisDetalheInstituicao"
        (onCloseModal)="showDetalhe=false"></app-mais-detalhes-intituicao-ensino>
      }
    </ng-template>
  </p-drawer>

</div>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>